import Entity from 'txp-data/lib/schema/Entity';

/**
 * Returns true if one or more entities have inferenceId
 */
export default function doesAnyEntityHaveInferenceId(txpEntities: {
    [entityId: string]: Entity;
}): string {
    return (!!Object.values(txpEntities)
        .filter(entity => entity.inferenceId != null)
        .shift()).toString();
}
